module.exports = __webpack_public_path__ + "static/media/66-iveco-mercedes.9f1fe277.jpg";